import * as ko from "knockout";

export class PopupConfig {
  popup_active: KnockoutObservable<boolean>;
  email_active: KnockoutObservable<boolean>;
  own_only: KnockoutObservable<boolean>;
  day_0: KnockoutObservable<boolean>;
  day_1: KnockoutObservable<boolean>;
  day_2: KnockoutObservable<boolean>;
  day_3: KnockoutObservable<boolean>;
  day_4: KnockoutObservable<boolean>;
  day_5: KnockoutObservable<boolean>;
  day_6: KnockoutObservable<boolean>;
  hour: KnockoutObservable<number>;
  ticket_single: KnockoutObservable<boolean>;
  ticket_list: KnockoutObservable<boolean>;
  filter_1: KnockoutObservable<boolean>;
  filter_2: KnockoutObservable<boolean>;
  filter_3: KnockoutObservable<boolean>;
  filter_4: KnockoutObservable<boolean>;
  message_from: KnockoutObservable<string>;

  constructor(params?) {
    this.popup_active = ko.observable(params?.popup_active === "Y");
    this.email_active = ko.observable(params?.email_active === "Y");
    this.own_only = ko.observable(params?.own_only ?? false);
    this.day_0 = ko.observable(params?.day_0 === "Y");
    this.day_1 = ko.observable(params?.day_1 === "Y");
    this.day_2 = ko.observable(params?.day_2 === "Y");
    this.day_3 = ko.observable(params?.day_3 === "Y");
    this.day_4 = ko.observable(params?.day_4 === "Y");
    this.day_5 = ko.observable(params?.day_5 === "Y");
    this.day_6 = ko.observable(params?.day_6 === "Y");
    this.hour = ko.observable(params?.hour ?? 0);

    this.ticket_single = ko.observable(params?.ticket_single === "Y");
    this.ticket_list = ko.observable(params?.ticket_list === "Y");

    this.filter_1 = ko.observable(params?.filter_1 === "Y");
    this.filter_2 = ko.observable(params?.filter_2 === "Y");
    this.filter_3 = ko.observable(params?.filter_3 === "Y");
    this.filter_4 = ko.observable(params?.filter_4 === "Y");

    this.message_from = ko.observable(params?.message_from);
  }
}
